import { useEffect, useRef, useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Space, Input, Tag, Tooltip } from 'antd';
import './index.scss';
import { cloneDeep } from 'lodash';
import { v4 as uuid } from 'uuid';
const GrtTag = function (props) {
    const { data = [], addOrEdit, del, clickTab } = props;
    const [tags, setTags] = useState();
    const [inputVisible, setInputVisible] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [editInputIndex, setEditInputIndex] = useState(-1);
    const [editInputValue, setEditInputValue] = useState('');
    const inputRef = useRef(null);
    const editInputRef = useRef(null);
    useEffect(() => {
        if (inputVisible) {
            inputRef.current?.focus();
        }
    }, [inputVisible]);
    useEffect(() => {
        editInputRef.current?.focus();
    }, [inputValue]);
    const handleClose = (removedTag) => {
        const newTags = tags.filter((tag) => tag.key !== removedTag.key);
        del && del(removedTag, newTags);
        setTags(newTags);
        if (newTags && newTags.length) {
            setSelectedKey(newTags[newTags.length - 1].key);
        }
    };
    const showInput = () => {
        setInputVisible(true);
    };
    const handleInputChange = (e) => {
        setInputValue(e.target.value);
    };
    const handleInputConfirm = () => {
        if (inputValue) {
            let tagsClone = cloneDeep(tags);
            tagsClone.push({ label: inputValue, key: uuid() });
            setTags(tagsClone);
            addOrEdit && addOrEdit(tagsClone);
            setSelectedKey(tagsClone[tagsClone.length - 1].key);
        }
        setInputVisible(false);
        setInputValue('');
    };
    const handleEditInputChange = (e) => {
        setEditInputValue(e.target.value);
    };
    const handleEditInputConfirm = () => {
        const newTags = cloneDeep(tags);
        newTags[editInputIndex].label = editInputValue;
        setTags(newTags);
        addOrEdit && addOrEdit(newTags);
        setEditInputIndex(-1);
        setInputValue('');
    };
    const tagInputStyle = {
        width: 78,
        verticalAlign: 'top',
    };
    const tagPlusStyle = {
        borderStyle: 'dashed'
    };
    const [selectedKey, setSelectedKey] = useState();
    const handleSelect = (tag) => {
        setSelectedKey(tag.key);
        clickTab && clickTab(tag);
    };
    useEffect(() => {
        if (data && data.length) {
            setTags(data);
            setSelectedKey(data[0].key);
        }
    }, [data]);
    return (<Space size={[0, 8]} wrap>
            <Space size={[0, 8]} wrap>
                {tags && tags.length > 0 && tags.map((tag, index) => {
            if (editInputIndex === index) {
                return (<Input ref={editInputRef} key={tag.key} size="small" style={tagInputStyle} value={editInputValue} onChange={handleEditInputChange} onBlur={handleEditInputConfirm} onPressEnter={handleEditInputConfirm}/>);
            }
            const isLongTag = tag.label.length > 20;
            const tagElem = (<Tag key={tag.key} closable style={{ userSelect: 'none' }} className={selectedKey === tag.key ? 'active-tag' : ''} onClick={() => handleSelect(tag)} onClose={() => handleClose(tag)}>
                            <span onDoubleClick={(e) => {
                    setEditInputIndex(index);
                    setEditInputValue(tag.label);
                    e.preventDefault();
                }}>
                                {isLongTag ? `${tag.label.slice(0, 20)}...` : tag.label}
                            </span>
                        </Tag>);
            return isLongTag ? (<Tooltip title={tag.label} key={tag.key}>
                            {tagElem}
                        </Tooltip>) : (tagElem);
        })}
            </Space>
            {inputVisible ? (<Input ref={inputRef} type="text" size="small" style={tagInputStyle} value={inputValue} onChange={handleInputChange} onBlur={handleInputConfirm} onPressEnter={handleInputConfirm}/>) : (<Tag style={tagPlusStyle} onClick={showInput}>
                    <PlusOutlined /> New Tag
                </Tag>)}
        </Space>);
};
export default GrtTag;
